import { useDispatch } from 'react-redux';

import { StaffStoreDispatch } from 'modules/staff/store/StaffStoreDispatch';

export const useStaffDispatch: () => StaffStoreDispatch = useDispatch;
